<template>
  <VPopover
    class="rating-tooltip"
    :trigger="tooltipOptions.trigger || 'hover'"
    :placement="tooltipOptions.placement || 'auto'"
    :offset="tooltipOptions.offset || 0"
    :open="!!tooltipOptions.open || undefined"
    :auto-hide="!!tooltipOptions.autoHide || false"
    default-arrow-class="input-tooltip__arrow"
  >
    <div class="tooltip-target b3">
      <slot name="parent" />
    </div>
    <template slot="popover">
      <div class="rating-tooltip__message">
        <div class="tooltip-v2__wrapper">
          <slot />
        </div>
      </div>
    </template>
  </VPopover>
</template>

<script>
import { VTooltip, VPopover } from 'v-tooltip';

export default {
  name: 'Tooltip',
  directives: {
    tooltip: VTooltip
  },
  components: {
    VPopover
  },
  props: {
    tooltipOptions: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip-v2 {
  &__wrapper {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    min-width: 220px;
    max-width: 50ch;
    width: fit-content;
    box-sizing: border-box;
    font-size: 14px;
    color: #36383e;
    line-height: 18px;
  }
}

.rating-tooltip {
  display: block;
  filter: drop-shadow(0px 4px 16px rgba(21, 32, 118, 0.1));

  &::v-deep .trigger {
    display: block !important;
  }
}

.rating-tooltip__message {
  padding: 0 !important;
}
</style>
